import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface MenuState {
    webUrls: string[]
    webChucNangs: Array<{
        url: string
        chucNangs: string[]
    }>
    webChucNangAll: string[]
    loading: boolean
    error: any
}

const initialState: MenuState = {
    webUrls: [],
    webChucNangs: [],
    webChucNangAll: [],
    loading: false,
    error: null,
}

export const menuDucks = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        getListMenuSuccess: (state, action: PayloadAction<{
            webUrls: string[]
            webChucNangs: Array<{
                url: string
                chucNangs: string[]
            }>
            webChucNangAll: string[]
        }>) => {
            state.loading = false
            state.webUrls = action.payload.webUrls
            state.webChucNangs = action.payload.webChucNangs
            state.webChucNangAll = action.payload.webChucNangAll
            state.error = null
        },
        getListMenuFail: (state, action: PayloadAction<any>) => {
            state.loading = false
            state.error = action.payload
            state.webUrls = []
            state.webChucNangs = []
            state.webChucNangAll = []
        },
    },
})

export const {
    getListMenuSuccess,
    getListMenuFail,
} = menuDucks.actions

export default menuDucks.reducer 